import * as React from 'react';
import { Checkbox } from '../../Checkbox';
import { AssetShareTarget } from './types';

export type AssetShareTargetCheckboxProps = Pick<React.HTMLAttributes<any>, 'style'> & {
    item: AssetShareTarget;
    selected: ReadonlyArray<string>;
    disabled: ReadonlyArray<string>;
    onChange: (selected: string[]) => void;
};

export const AssetShareTargetCheckbox: React.FC<AssetShareTargetCheckboxProps> = ({
    disabled,
    item,
    onChange,
    selected,
    ...props
}) => {
    const isChecked = selected.includes(item.id);
    const isDisabled = disabled.includes(item.id);
    const remainingCollectionCount = item.maxCollections - item.currentCollections;
    const maxedCollectionCount = remainingCollectionCount <= 0 && !isChecked;
    const displayedCollectionCount = item.currentCollections + (isChecked ? 1 : 0);
    return (
        <Checkbox
            {...props}
            checked={isChecked}
            disabled={isDisabled || maxedCollectionCount}
            type="checkbox"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                if (event.target.checked) {
                    onChange([...selected, item.id]);
                } else {
                    onChange(selected.filter(id => id !== item.id));
                }
            }}
        >
            <div>
                <div>{item.title}</div>
                <small className="text-muted">
                    {`(collections ${displayedCollectionCount}/${item.maxCollections})`}
                </small>
            </div>
        </Checkbox>
    );
};
AssetShareTargetCheckbox.displayName = 'AssetShareTargetCheckbox';
